import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseStorageBucket',
  initialState: null as null | string,
  reducers: {
    setFirebaseStorageBucket(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseStorageBucket } = slice.actions;

export default slice.reducer;
